import { Component, OnInit } from '@angular/core';
import { AuthService } from '@core/auth/auth.service';
import { environment } from '../../../environments/environment';
import jwt_decode from 'jwt-decode';
import { ProfileService } from '@app/shared/services/profileservice';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ConfirmationDialog } from '@app/modules/compliance/component/confirmation-dialog.component';
import { ThemeService } from '@app/shared/services/themeservice';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html'
})
export class ProfileComponent implements OnInit {
  profileJson: string = null;
  roles: string;
  institutioncolleges: string;
  assignedsports: string;
  message:string;
  public styleObj = {
    lsu :  {
      '--baseprimarycolor': '#461D7C',
      '--baseaccentcolor': '#FDD023'      
    },
    invested:
    {
      '--baseprimarycolor': '#21c87a',
      '--baseaccentcolor': '#6c757d'  
    },
    RichElectricBlue : {
      '--baseprimarycolor': '#009EDB',
      '--baseaccentcolor': '#EEA47F'      
    },
    Royalbluepeach :  {
      '--baseprimarycolor': '#00539C',
      '--baseaccentcolor': '#EEA47F'      
    },
    Bluepink : {
      '--baseprimarycolor': '#2F3C7E',
      '--baseaccentcolor': '#FBEAEB'      
    },
    Charcoalyellow : {
      '--baseprimarycolor': '#101820',
      '--baseaccentcolor': '#FEE715'      
    }    ,
    SimmonsUniversity : {
      '--baseprimarycolor': '#033a6e',
      '--baseaccentcolor': '#eec04e'      
    } 
  }
  constructor(public auth: AuthService,public service:ProfileService, private dialog: MatDialog,public themeService:ThemeService) { }
  ngOnInit() {
    this.auth.userProfile$.subscribe(
      profile => {
        this.roles = profile[environment.roleClaim];
        if(this.roles.length==0){
            this.fetchProfile();
        }      
      }
    );
    this.auth.getTokenSilently$().
      subscribe(
        token => {
          if (token != null) {
            var profile= jwt_decode(token);
            this.institutioncolleges = profile[environment.institutioncolleges];
            this.assignedsports = profile[environment.assignedsports];
           }
        }
      ); 
  }

  fetchProfile(){
   this.service.fetchProfile().subscribe(data => {
        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: data.value.message }
        });
        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
          if(data.value.logout){
            this.auth.logout();
          }
        });
    });
  } 

  applyTheme(styleObj:any){
    this.themeService.setTheme(styleObj);
  }

}
